import { API_ROOT } from '../apiConfig';
import axios from 'axios';

export const profileUpdateResult = (userId,profileUpdate) => {
	let finalUrl = `${API_ROOT}`+'/api/AppUsers/updateProfile?userID=' + userId + '&profile=' + JSON.stringify(profileUpdate)
			
	return axios.put(finalUrl)
		.then(response => response)
}